module.exports = __webpack_public_path__ + "static/img/4299_phase_function_Paper_Points.711b17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4299_phase_function_Paper_Points.png
// module id = MDxo
// module chunks = 0